import React from 'react';
import { formatDateAndTime } from '@/utils/utils';
import { Col, Row, Tooltip } from 'antd';
import styles from './OverviewInfoBar.module.css';
import { isEmpty } from 'lodash';

const OverviewInfoBar = ({ cloudAccountData }) => {
  return (
    <Row style={{ marginBottom: 36 }}>
      <Col span={8} className={styles['section_wrapper']}>
        <Row>
          <Col span={12}>
            <div className={styles['subHeading']}>Created by</div>
            <div className={styles['content']}>
              <b>{cloudAccountData.createdBy ? cloudAccountData.createdBy : 'N/A'}</b>
            </div>
            {!isEmpty(cloudAccountData.createdAt) && (
              <Tooltip title={formatDateAndTime(cloudAccountData?.createdAt?.toDate()).exactTime}>
                <div className={styles['content']}>
                  {formatDateAndTime(cloudAccountData?.createdAt?.toDate()).relativeTime}
                </div>
              </Tooltip>
            )}
          </Col>
          <Col span={12} className={styles['left_side_border']}>
            <div className={styles['subHeading']}>Updated by</div>
            <div className={styles['content']}>
              <b>{cloudAccountData.updatedBy ? cloudAccountData.updatedBy : 'N/A'}</b>
            </div>
            {!isEmpty(cloudAccountData.updatedAt) && (
              <Tooltip title={formatDateAndTime(cloudAccountData?.updatedAt?.toDate()).exactTime}>
                <div className={styles['content']}>
                  {formatDateAndTime(cloudAccountData?.updatedAt?.toDate()).relativeTime}
                </div>
              </Tooltip>
            )}
          </Col>
        </Row>
      </Col>

      <Col span={14} className={styles['section_wrapper']}>
        <Row>
          <Col span={4}>
            <div className={styles['subHeading']}>Status</div>
            <p className={styles['content']}>{cloudAccountData.isActive ? 'Active' : 'Inactive'}</p>
          </Col>
          <Col span={6} className={styles['left_side_border']}>
            <div className={styles['subHeading']}>Monitoring</div>
            <p className={styles['content']}>
              {cloudAccountData.intervalStatus
                ? cloudAccountData.interval
                    .toLowerCase()
                    .charAt(0)
                    .toUpperCase() + cloudAccountData.interval.toLowerCase().slice(1)
                : 'Off'}
            </p>
          </Col>
          <Col span={7} className={styles['left_side_border']}>
            <div className={styles['subHeading']}>Protection Level</div>
            <p className={styles['content']}>
              {cloudAccountData.protectionLevel
                ? cloudAccountData?.protectionLevel.charAt(0).toUpperCase() +
                  cloudAccountData?.protectionLevel.slice(1)
                : 'Basic'}
            </p>
          </Col>
          <Col span={7} className={styles['left_side_border']}>
            <div className={styles['subHeading']}>Last Scanned</div>
            {!isEmpty(cloudAccountData?.lastScan) ? (
              <Tooltip title={formatDateAndTime(cloudAccountData?.lastScan.toDate()).exactTime}>
                <p className={styles['content']}>
                  {formatDateAndTime(cloudAccountData?.lastScan.toDate()).relativeTime}
                </p>
              </Tooltip>
            ) : (
              <div className={styles['content']}>
                <b>N/A</b>
              </div>
            )}
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default OverviewInfoBar;
